module.exports = __webpack_public_path__ + "img/6.43a4fd0b.png";